import { JournalEntryItem } from "./JournalEntryItem";
export default JournalEntryItem;
